import template from 'text!./generalCoverages.html';
import controller from './generalCoveragesCtrl';

/**
 * @ngdoc component
 * @name gw-bop-general-coverages
 *
 * @description  A bop component to display the general coverages step into a wizard flow
 *
 */
export default {
    controller: controller,
    template: template,
    bindings: {
        updateCoverages: '='
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/coverages/general/index.js
// module id = 970
// module chunks = 0